import React from 'react';
import { useSelector } from 'react-redux';

import Button from '../commons/Button';

const ProcessLoader = () => {
  const {
    totalSteps,
    currentStep,
    humanMessage,
    apiMessage,
    buttonLabel,
    buttonIcon,
    buttonIconPosition,
    buttonAction,
    image,
  } = useSelector((state) => state.ui.processStatus);

  return (
    <div className="app-loader">
      <div className={`app-loader-inner -process -${image}`}>
        <p>
          Paso&nbsp;
          {currentStep}
          &nbsp;de&nbsp;
          {totalSteps}
        </p>
        <div className="loader-icon" />
        <p>{humanMessage}</p>
        {apiMessage && (
          apiMessage.split('%%').map((message) => <p key={message}>{message}</p>)
        )}
        {
          buttonIcon && buttonLabel && buttonAction && (
            <Button
              onClick={buttonAction}
              label={buttonLabel}
              iconPosition={buttonIconPosition}
              buttonClasses="align-center"
              iconClasses={buttonIcon} />
          )
        }
      </div>
    </div>
  );
};

export default ProcessLoader;
